"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || (function () {
    var ownKeys = function(o) {
        ownKeys = Object.getOwnPropertyNames || function (o) {
            var ar = [];
            for (var k in o) if (Object.prototype.hasOwnProperty.call(o, k)) ar[ar.length] = k;
            return ar;
        };
        return ownKeys(o);
    };
    return function (mod) {
        if (mod && mod.__esModule) return mod;
        var result = {};
        if (mod != null) for (var k = ownKeys(mod), i = 0; i < k.length; i++) if (k[i] !== "default") __createBinding(result, mod, k[i]);
        __setModuleDefault(result, mod);
        return result;
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
exports.InsertWorkEmail = void 0;
const react_1 = __importStar(require("react"));
const Button_1 = require("@food/ui/build/dist/src/Button");
const Field_1 = require("@food/ui/build/dist/src/Field");
const ErrorMessage_1 = require("@food/ui/build/dist/src/ErrorMessage");
const theme_1 = require("../utils/theme");
const misc_1 = require("../utils/misc");
const css_manager_1 = require("@food/css-manager");
const style = (0, css_manager_1.registerClass)((t, sc) => `
	.${sc('input')} > label {
		font-size: ${t.ratios.l}em;
		margin-bottom: 0;
	}
	
	.${sc('strong')} {
		font-weight: ${t.font.weights.bold};
	}
	
	.${sc('error')} {
		margin-top: ${t.ratios.s * t.font.baseSize}px;
	}
`);
const sc = (0, css_manager_1.currySC)(style);
const hasErrors = (errors, filters) => {
    if (errors && errors.length) {
        return (errors.filter((e) => {
            if (filters.context && filters.context === e.context) {
                return true;
            }
            if (filters.key && filters.key === e.key) {
                return true;
            }
            return filters.type && filters.type === e.type;
        }).length > 0);
    }
    return false;
};
const InsertWorkEmail = ({ presetWorkEmail, t, back, errors, performRegister, supportEmail, }) => {
    const [email, setEmail] = (0, react_1.useState)(presetWorkEmail || '');
    // il modo in cui il server mi suggerisce che devo inserire la work email e' un errore. Quindi e' come
    // se partissi gia' con un errore di validazione! Filtro questo errore poiche' non e' significativo per il
    // flusso di lavoro dell'utente
    const realErrors = errors
        ? errors.filter((e) => e.type !== 'EMPTY_NOT_ALLOWED')
        : [];
    let message = react_1.default.createElement(ErrorMessage_1.ErrorMessage, { error: t('generic email error') });
    const errorState = hasErrors(realErrors, {
        key: 'options.workEmail',
    });
    // dati i possibili messaggi che mi restituisce il server devo scegliere quale messaggio visualizzare
    if (errorState) {
        const error = realErrors.filter((e) => e.key === 'options.workEmail')[0];
        if (error.type === 'MUST_BE_UNIQUE') {
            message = (react_1.default.createElement(ErrorMessage_1.ErrorMessage, { error: t('alreadyUsedEmail error').replace('$SUPPORT_EMAIL', supportEmail) }));
        }
        else if (error.type === 'INVALID_VALUE') {
            message = react_1.default.createElement(ErrorMessage_1.ErrorMessage, { error: t('consumerOnlyEmail error') });
        }
        else if (error.type === 'UNSUPPORTED_FORMAT') {
            message = react_1.default.createElement(ErrorMessage_1.ErrorMessage, { error: t('wrongEmailFormat error') });
        }
    }
    return (react_1.default.createElement(react_1.default.Fragment, null,
        react_1.default.createElement("h2", null, t `Registration - Business Profile`),
        react_1.default.createElement("section", { className: style },
            react_1.default.createElement("div", null,
                t `We reserve specific functionalities to suppliers, buyers and food service operators so we have to be sure you work in the food business.`,
                react_1.default.createElement("br", null),
                react_1.default.createElement("span", { className: sc('strong') },
                    t `We can't accept public email domains (@gmail.com, @aol.com, ...)`,
                    ". ",
                    t `If your company doesn't have a private email domain`,
                    ' ',
                    react_1.default.createElement("a", { href: `mailto:${supportEmail}` }, t `contact us`),
                    ".")),
            react_1.default.createElement(Field_1.Field, { id: 'email', label: t `Insert your job email address`, error: errorState, className: sc('input') },
                react_1.default.createElement("input", { id: "email", type: "email", onChange: (event) => setEmail(event.target.value), value: email }),
                email && email.length && errorState && (react_1.default.createElement("div", { className: (0, css_manager_1.cns)(theme_1.defaultMarginBottom, sc('error')) }, message))),
            react_1.default.createElement("div", { className: theme_1.footer },
                react_1.default.createElement(Button_1.Button, { label: t `Back`, onClick: back }),
                react_1.default.createElement(Button_1.Button, { label: t `Continue`, type: 'success', disabled: !(0, misc_1.validateEmail)(email), onClick: () => performRegister(email) })))));
};
exports.InsertWorkEmail = InsertWorkEmail;
//# sourceMappingURL=InsertWorkEmail.js.map